import * as R from 'ramda';
import { ActionType } from '../../core/redux/actionType';
import { AppState } from '../../core/redux/appState';
import { Action } from 'redux';


type SetLastOnlyAction = {
  type: ActionType.SetLastOnly;
  lastOnly: boolean;
}


/**
 * Dispatch this set the report recipient last only value.
 * @param lastOnly - the new last only state you want (default: true)
 */
export const setLastOnlyAction = (lastOnly: boolean = true): SetLastOnlyAction => ({
  type:     ActionType.SetLastOnly,
  lastOnly: lastOnly,
});


export const setLastOnlyReducer = (state: AppState, incomingAction: Action): AppState => {
  if (incomingAction.type !== ActionType.SetLastOnly) {
    return state;
  }
  
  const action = incomingAction as SetLastOnlyAction;

  return R.assoc('reportRecipientLastOnly', action.lastOnly, state);
};
